import React, { useContext, useState, useEffect } from 'react';
import { baseUrl } from '../utils/constants';

const initialState = {
  currentProduct: {},
  productRefId: -1
};

const initialProduct = {
  productCode: 0,
  nappiCode: '',
  coded: false,
  productName: '',
  dosage: '',
  quantity: 0,
  sellingPrice: 0,
  costPrice: 0,
  vatPercent: 0,
  taxItem: false,
  units: 0,
  reorderLevel: 0,
  leadTime: 0,
  stockCount: 0,
  categoryId: 0,
  groupId: 0,
  groupings: 0
};

export const ProductContext = React.createContext();

export const ProductProvider = ({ children }) => {
  const [productRefId, setProductRefId] = useState(-1);
  const [currentProduct, setCurrentProduct] = useState(initialProduct);
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    // getProductList();
  }, []);

  const refreshProductValues = (productRefId) => {
    if (productRefId > 0) {
      populateProductList(productRefId);
    } else {
      setProductRefId(-1);
      setCurrentProduct(initialProduct);
      console.log('just cleared all products');
    }
  };

  const populateProductList = async () => {
    const response = await fetch(`${baseUrl}/api/product/getproducts`);
    const data = await response.json();
    console.log('product data received', data);
    setCurrentProduct(data.products[0]);
  };

  const getProductView = async (productRefId) => {
    fetch(`${baseUrl}/api/product/getproductforviewmodel?productRefId=${productRefId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned individual product', result);
          setCurrentProduct(result.product);
          setProductRefId(result.product.refId);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getProductListByProduct = async (productRefId) => {
    fetch(`${baseUrl}/api/product/GetProductCostByProduct?productRefId=${productRefId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('product cost data receivedsss', result);
          setProductList(result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getProductList = async () => {
    fetch(`${baseUrl}/api/product/GetProducts`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('products receivedsss', result);
          setProductList(result.result);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  return (
    <ProductContext.Provider
      value={{
        productRefId,
        setProductRefId,
        currentProduct,
        setCurrentProduct,
        refreshProductValues,
        getProductView,
        productList,
        getProductList
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProductContext = () => useContext(ProductContext);
